export default __webpack_public_path__ + "static/media/login-img.7f33b9f0.svg";